<template>
  <div class="text bg messge">
    <Nav>
      <i class="el-icon-arrow-left btn" slot="prefix" @click="$router.back()"></i>
      {{chatMessage.title}}
      <i
        class="el-icon-more btn"
        slot="suffix"
        @click="$router.push({name:'groupSet',params:{id:id}})"
      ></i>
    </Nav>
    <div class="content" id="text-list">
      <template v-for="(item, idx) in chatMessage.chats">
        <div
          class="date-format"
          v-if="showDate(item,idx,chatMessage.chats)"
          :key="'date-'+idx"
        >{{item.date|chatTime}}</div>
        <div
          class="msg-item"
          :key="'content-'+idx"
          :class="[item && item.user_id == current_user.ID ? 'right-msg' : 'content-msg']"
          v-if="item"
        >
          <span class="name">{{item.name}}</span>
          <div class="msg-body">
            <template v-if="item.data">
              <template v-if="item.type == 'image/jpeg' || item.type == 'image/png'">
                <img :src="item.data" class="img" @click="showBig(item.data)" />
              </template>
              <template v-else-if="item.type == 'application/pdf'">
                <div class="file-data" @click="download(item.data)">
                  <img src="../../public/pdf.png" />
                  <p>{{item.data.split("/")[item.data.split("/").length - 1]}}</p>
                  <div class="handle">
                    <el-button @click="download(item.data)">下载</el-button>
                  </div>
                </div>
              </template>
              <template
                v-else-if="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' == item.type"
              >
                <div class="file-data" @click="download(item.data)">
                  <img src="../../public/excel.png" />
                  <p>{{item.data.split("/")[item.data.split("/").length - 1]}}</p>
                  <div class="handle">
                    <el-button @click="download(item.data)">下载</el-button>
                  </div>
                </div>
              </template>
              <template v-else-if="'application/msword' == item.type">
                <div class="file-data">
                  <img src="../../public/word.png" />
                  <p>{{item.data.split("/")[item.data.split("/").length - 1]}}</p>
                  <div class="handle">
                    <el-button @click="download(item.data)">下载</el-button>
                  </div>
                </div>
              </template>
              <template
                v-else-if="['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'].includes(item.type)"
              >
                <div class="file-data" @click="download(item.data)">
                  <img src="../../public/ppt.png" />
                  <p>{{item.data.split("/")[item.data.split("/").length - 1]}}</p>
                  <div class="handle">
                    <el-button @click="download(item.data)" size="mini">下载</el-button>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="file-data">
                  <img src="../../public/zip.png" />
                  <p>{{item.data.split("/")[item.data.split("/").length - 1]}}</p>
                  <div class="handle">
                    <el-button @click="download(item.data)">下载</el-button>
                  </div>
                </div>
              </template>
            </template>
            <span v-else class="msg-style-body">{{item.content}}</span>
            <span
              v-if="item.timeago < 3 && item.user_id == current_user.ID"
              class="recall"
              @click="recall(item)"
            >
              <span>撤回</span>
              <img src="@/assets/icon-recall.svg" />
            </span>
          </div>
        </div>
      </template>
    </div>
    <div class="plugin">
      <div class="plugin-set">
        <el-upload
          :action="actionUrl"
          :show-file-list="false"
          :on-success="sendUpload"
          :before-upload="checkFile"
          :on-progress="uploadProcess"
          :on-error="uploadError"
        >
          <i
            slot="trigger"
            class="el-icon-picture btn upload"
            :class="{active:loading}"
            size="small"
          ></i>
        </el-upload>
      </div>
      <div
        class="input-text"
        v-if="!noSelect"
        v-loading="loading"
        :element-loading-text="'正在上传'+process+'%'"
      >
        <at :members="users.map(i => i.name)" style="width:100%;height:100%;">
          <div
            ref="paste"
            type="text"
            placeholder="输入内容"
            class="input-text-form"
            contenteditable
            @paste.stop.prevent="pasteImage($event)"
            @input="onInput"
            @drop.prevent="addFile"
            @dragover.prevent
            @keydown.enter="send"
          ></div>
        </at>
        <div class="btn-send">
          <el-button @click="send" icon="el-icon-s-promotion">发送</el-button>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="show" top="1%" :before-close="handleClose">
      <img :src="images" class="show-image" />
    </el-dialog>
  </div>
</template>
<script>
import { formatDate, formatTime, timeSince, chatTime } from "../util";
import axios from "axios";
import At from "vue-at";
import Nav from "@/components/Nav";
export default {
  filters: { chatTime },
  components: { At, Nav },
  props: { id: [String, Number] },
  data() {
    return {
      images: null,
      show: false,
      current_user: JSON.parse(localStorage.getItem("user") || "{}"),
      actionUrl: process.env.VUE_APP_BASE_URL + "/upload",
      loading: false,
      process: 0,
      users: [],
      chatMessage: {},
      page: 1,
      has_next: true,
      noSelect: "",
      groups: []
    };
  },
  created() {
    this.getChat(this.id);
    this.getGroupUser(this.id);
  },
  methods: {
    handleClose() {
      this.images = false;
      this.show = false;
    },
    recall(item) {
      // console.log("sd", item);
      this.$api
        .recallMessage({ id: item.room_id, recall: item.ID })
        .then(res => {
          if (res.code == 200) {
            this.chatMessage.chats.splice(
              this.chatMessage.chats.findIndex(i => i.ID == item.ID),
              1
            );
          }
        });
    },
    chatLog() {
      this.$nextTick(() => {
        var div = document.getElementById("text-list");
        div.scrollTop = div.scrollHeight;
      });
    },
    getChat(id) {
      this.$api.getChat({ id: id }).then(res => {
        let tid = res.result.chat.token;
        this.chatMessage = res.result.chat;
        this.$api
          .getMessage({ room_id: id, page: 1, limit: 100 })
          .then(result => {
            this.chatMessage.chats = result.result.messages.reverse().map(i => {
              i.timeago = timeSince(i.date);
              return i;
            });
            this.page = 1;
            this.has_next = result.result.page.has_next;
            this.chatLog();
            localStorage.removeItem(tid);
            this.groups[this.chatMessage];
            // this.groups.map(i => {
            //   if (i.ID == e) {
            //     i.notify_count = 0;
            //   }
            //   return i;
            // });
          });
      });

      this.connectService();
    },
    getGroupUser(id) {
      this.$api.getRoomInfo({ id: id, users: true }).then(res => {
        this.users = [...res.result.users];
      });
    },
    getGroups() {
      this.$api.groups().then(res => {
        this.groups = res.result.groups.map(i => {
          let cnt = localStorage.getItem(i.token);
          i.notify_count = cnt ? cnt : 0;
          return i;
        });
        this.connectService();
      });
    },
    connectService() {
      var uri = `${process.env.VUE_APP_SOCKET_URL}/ws?utoken=${this.current_user.token}&uid=${this.current_user.ID}`;
      this.sock = new WebSocket(uri);
      this.sock.onmessage = this.message_event;
      this.sock.onopen = this.open_event;
      this.sock.onerror = this.error_event;
      this.sock.onclose = this.close_event;
    },
    open_event() {
      console.log("连接成功");
    },
    error_event(e) {
      console.log("关闭连接", e);
      this.sock.close();
    },
    notify(title, content) {
      this.$notification.show(title, { body: content }, {});
    },
    handleNotifyCount(token, count) {
      if (this.chatMessage.token == token) {
        this.chatMessage.notify_count = count;
      }
      // this.groups.map(i => {
      //   if (i.token == token) {
      //     i.notify_count = count;
      //   } else {
      //     i.notify_count = 0;
      //   }
      //   return i;
      // });
    },
    message_event(e) {
      // console.log("message e:", e);
      let data = JSON.parse(e.data);
      if (data.Sender == "") {
        return;
      }
      if (
        this.current_user.token != data.Sender &&
        data.Content.event != "recall"
      ) {
        var cnt = localStorage.getItem(data.Recipient);
        if (!cnt) {
          localStorage.setItem(data.Recipient, 1);
          this.handleNotifyCount(data.Recipient, 1);
        } else {
          localStorage.setItem(data.Recipient, parseInt(cnt) + 1);
          this.handleNotifyCount(data.Recipient, parseInt(cnt) + 1);
        }

        if (data.Content.content) {
          this.notify(
            data.Content.room_title,
            `${data.Content.name}: ${data.Content.content}`
          );
        } else if (data.Content.data && data.Content.data.length > 10) {
          this.notify(
            data.Content.room_title,
            `${data.Content.name}: 发了一个文件`
          );
        }
      }
      if (data.Sender == "system") {
        if (data.Content.event == "recall") {
          this.chatMessage.chats.splice(
            this.chatMessage.chats.findIndex(
              i => i.ID == parseInt(data.Content.mid)
            ),
            1
          );
          return;
        }
        if (data.Content.event == "new_group") {
          if (this.current_user.token == data.Recipient) {
            this.groups = [data.Content.room].concat(this.groups);
          }
        } else if (data.Content.event == "project") {
          if (this.chatMessage.token == data.Recipient) {
            if (data.Content.status == 1) {
              this.keys.map(i => {
                if (i.title == data.Content.filename) {
                  i.status = 1;
                }
                return i;
              });
            } else {
              let exists = this.keys.filter(
                i => i.title == data.Content.filename
              );
              if (exists.length > 0) {
                return;
              }
              this.keys.push({ title: data.Content.filename, status: 0 });
            }
          }
        } else if (data.Content.event == "delete") {
          let gidx = this.groups.findIndex(i => i.ID == data.Content.room_id);
          this.groups.splice(gidx, 1);
          if (data.Content.room_id == this.id) {
            this.chatMessage = {};
            this.noSelect = true;
            localStorage.removeItem("group");
          }
        }
        return;
      }
      data.Content.date = parseInt(data.Content.date);
      if (this.chatMessage.token == data.Recipient) {
        data.Content.timeago = timeSince(data.Content.date);
        // console.log("chatMessage:", this.chatMessage);
        if (this.chatMessage) {
          if (this.chatMessage.chats) {
            this.chatMessage.chats.push(data.Content);
          } else {
            this.chatMessage.chats = [data.Content];
          }
        }
      }
      // console.log('groups:',this.groups)
      let gps = this.groups.filter(i => i.token == data.Recipient)[0];
      // console.log("gps:", this.groups, gps);
      if (gps) {
        if (gps.chats == null) {
          gps.chats = [data.Content];
        } else {
          gps.chats.unshift(data.Content);
        }
      }
      this.chatLog();
    },
    close_event(e) {
      console.log("连接关闭, 正在一秒后重新连接", e.reason);
      setTimeout(() => {
        this.connectService();
      }, 5000);
    },
    showDate(item, idx, chats) {
      const last = chats[idx - 1];
      if (last && item) {
        const diff = Math.abs(last.date / 1000 - item.date / 1000);
        // console.log('if show date:',diff,item.date,last.date)
        return diff > 60;
      }
      return false;
    },
    showBig(e) {
      this.images = e;
      this.show = true;
    },
    download(e) {
      window.location.href = e;
    },
    sendUpload(res, file, filelist) {
      this.loading = false;
      if (res.code === 200) {
        let data = res.result.url;
        let size = res.result.size;
        let type = res.result.type["Content-Type"][0];
        let msg = {
          name: this.current_user.name,
          type: type,
          data: data,
          size: size.toString(),
          user_id: this.current_user.ID,
          room_id: this.chatMessage.ID,
          room_title: this.chatMessage.title,
          room_token: this.chatMessage.token,
          recipient: this.chatMessage.token,
          date: new Date().getTime().toString()
        };
        this.sock.send(JSON.stringify(msg));
        this.chatLog();
      }
    },
    checkFile(file) {
      const limit = file.size / 1024 / 1024 < 3096;
      if (!limit) {
        this.$alert("文件超过了 3G");
        return false;
      }
    },
    uploadProcess(event, file, filelist) {
      this.loading = true;
      this.process = Math.round((event.loaded * 100) / event.total);
    },
    uploadError() {
      this.loading = false;
      this.$message.error({ message: "上传文件失败" });
    },
    pasteImage(e) {
      const cbd = e.clipboardData;
      const ua = window.navigator.userAgent;
      if (!(e.clipboardData && e.clipboardData.items)) {
        return;
      }
      let value = cbd.getData("text/plain");
      if (value.length > 0) {
        this.msg = value;
        var node = document.createElement("span");
        node.innerHTML = value;
        this.$refs.paste.appendChild(node);
        return;
      }
      if (
        cbd.items &&
        cbd.items.length === 2 &&
        cbd.items[0].kind === "string" &&
        cbd.items[1].kind === "file" &&
        cbd.types &&
        cbd.types.length === 2 &&
        cbd.types[0] === "text/plain" &&
        cbd.types[1] === "Files" &&
        ua.match(/Macintosh/i) &&
        Number(ua.match(/Chrome\/(\d{2})/i)[1]) < 49
      ) {
        return;
      }
      for (let i = 0; i < cbd.items.length; i++) {
        let item = cbd.items[i];
        if (item.kind == "file") {
          const blob = item.getAsFile();
          if (blob.size === 0) {
            return;
          }
          const reader = new FileReader();
          const imgs = new Image();
          imgs.file = blob;
          this.paste_value = "file";
          reader.onload = (function(aImg) {
            return function(e) {
              aImg.src = e.target.result;
            };
          })(imgs);
          reader.readAsDataURL(blob);
          this.paste_file = blob;
          this.$refs.paste.appendChild(imgs);
        }
      }
    },
    onInput(e) {
      this.msg = e.target.innerText;
    },
    addFile(e) {
      let fs = e.dataTransfer.files;
      let f = fs[0];
      this.paste_file = f;
      this.sendPasteFile();
    },
    send() {
      if (this.paste_value == "file") {
        this.sendPasteFile();
        return;
      }
      let m = this.msg.trim();
      if (this.msg.length <= 0 || m.length <= 0) {
        return;
      }

      var msg = {
        name: this.current_user.name,
        ID: this.current_user.ID,
        content: this.msg,
        type: "text",
        user_id: this.current_user.ID,
        room_id: this.chatMessage.ID,
        room_title: this.chatMessage.title,
        room_token: this.chatMessage.token,
        recipient: this.chatMessage.token,
        date: new Date().getTime().toString()
      };
      this.msg = "";
      this.$refs.paste.innerHTML = "";
      this.sock.send(JSON.stringify(msg));
    }
  }
};
</script>
<style lang="scss" scoped>
.messge {
  // height: calc(100% - 70px);
  position: relative;
  .content {
    height: calc(100vh - 144px);
    overflow-y: auto;
    background: hsla(0, 0%, 95%, 1);
    // padding-bottom: 50px;
    .date-format {
      text-align: center;
      font-size: 12px;
      color: hsla(0, 0%, 60%, 1);
    }
    .msg-item {
      margin: 15px 0;
      display: flex;
      flex-direction: row;
      .name {
        margin: 0 20px;
        min-width: 45px;
        font-size: 14px;
        color: hsla(0, 0%, 20%, 1);
      }
      .msg-body {
        max-width: 70%;
        border-radius: 3px 8px 8px 8px;
        background: hsla(0, 0%, 100%, 1);
        padding: 10px;
        // max-height: 70vw;
        .img {
          max-width: 100%;
          // max-height: 100%;
          object-fit: contain;
        }
        .msg-style-body {
          color: hsla(0, 0%, 20%, 1);
          font-size: 14px;
          line-height: 24px;
        }
        .handle-event {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
    }
    .right-msg {
      flex-direction: row-reverse;
      .msg-body {
        max-width: 70%;
        border-radius: 8px 3px 8px 8px;
        background: #d3f4f3;
        position: relative;
        // display: flex;
        // justify-content: flex-start;
        // user-select: none; // for mobile long press
        .img {
          // object-fit: contain;
        }
        .recall {
          display: none;
          justify-content: flex-end;
          align-items: center;
          position: absolute;
          left: -26px;
          bottom: 0;
          // border: 1px dashed red;
          z-index: 101;
          width: 90px;
          padding-right: 10px;
          span {
            margin-right: 2px;
            color: #666;
            font-size: 12px;
          }
          img {
            width: 26px;
            height: 26px;
            // margin-left: 10px;
          }
        }
        .recall:hover {
          color: hsla(180, 64%, 42%, 1);
          // background: hsla(180, 64%, 42%, 0.05);
        }
      }
      .msg-body:hover {
        .recall {
          display: flex;
          left: -85px;
          color: hsla(180, 64%, 42%, 1);
          cursor: pointer;
        }
      }
    }
  }
  .plugin {
    // border: 1px dashed red;
    border-top: 1px solid hsla(0, 0%, 86%, 1);
    height: 100px;
    .plugin-set {
      // border: 1px dashed deepskyblue;
      .upload {
        // border: 1px dashed red;
        font-size: 18px;
        margin: 10px 20px;
      }
    }
    .input-text {
      height: 60px;
      // border: 1px dashed deepskyblue;
      position: relative;
      .input-text-form {
        padding: 5px;
        height: 100%;
        outline: none;
        background: #f0f0f0;
        // border: 1px dashed skyblue;
      }
      .btn-send {
        position: absolute;
        top: 10px;
        right: 5px;
        // bottom: 10px;
        z-index: 102;
      }
    }
  }
  .keys {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 103;
    width: 300px;
    height: 710px;
    background: hsla(0, 0%, 95%, 1);
    border-left: 1px solid hsla(0, 0%, 90%, 1);
    /deep/ .el-tabs__item {
      height: 60px;
      line-height: 60px;
    }
    /deep/ .el-tabs__item.is-active {
      color: hsla(180, 64%, 42%, 1);
    }
    /deep/ .el-tabs__active-bar {
      background-color: hsla(180, 64%, 42%, 1);
    }
  }
  /deep/ .el-dialog {
    width: 100%;
    // max-width: 100%;
    .show-image {
      width: 100%;
    }
  }
}
</style>